import React, { Component } from 'react';
import { View, TouchableOpacity, Platform, Dimensions } from 'react-native';

import Text from '../../react-component/textComponent';

import Colors from '../../config/Colors';
import styles from './styles';

const { width } = Dimensions.get('window'),
    isDesktop = Platform.OS === 'web' && width > 720;

export default class ListIcon extends Component {
    render() {
        const { onPress = null } = this.props;

        if (onPress) {
            return (
                <TouchableOpacity onPress={onPress}>
                    {this.renderItem()}
                </TouchableOpacity>
            );
        }

        return this.renderItem();
    }

    renderItem = () => {
        const {
                Icon,
                label,
                color = Colors.dark,
                separator,
                title,
                boldTitle = false,
            } = this.props,
            styleSeparator = separator ? styles.itemSeparator : null,
            stylesLabel = Icon
                ? styles.label
                : [styles.label, { marginLeft: 0 }],
            maxWidth = isDesktop ? width - 580 : width - 120;

        return (
            <View
                style={[
                    styles.content,
                    styleSeparator,
                    this.props.style,
                ]}
            >
                {Icon && (
                    <Icon
                        sx={{
                            fontSize: 26,
                            color: color,
                        }}
                        style={styles.icon}
                    />
                )}
                <Text
                    style={[
                        stylesLabel,
                        { maxWidth: maxWidth }
                    ]}
                >
                    {title && (
                        <Text
                            bold={boldTitle}
                            style={{
                                borderBottomWidth: 0,
                                paddingRight: 10
                            }}
                        >
                            {title}
                        </Text>
                    )}
                    {label}
                </Text>
            </View>
        );
    };
}
